import React from 'react';
import { is } from '../../../services/classify';
import { Accordion } from '../../accordion';
import clsx from 'clsx';
import { useTrilogyContext } from '../../../context';
import { hashClass } from '../../../helpers';
/**
 * Footer Desktop Component
 * @param children {ReactNode} Desktop Footer Children
 * @param className {string} Additionnal CSS Classes
 * @param fullwidth {boolean} Footer fullwidth
 */
const FooterDesktop = ({ children, className, fullwidth, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx(is('hidden-touch'), is('footer-desktop'), fullwidth && is('fullwidth'), className));
    // Desktop Footer
    return (React.createElement(Accordion, { className: classes, ...others }, children));
};
export default FooterDesktop;
//# sourceMappingURL=FooterDesktop.js.map